import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../HomeView.vue'
import ZeekrView from '../zeekr.vue'
import ZeekrEvent from '../zeekrevent.vue'

import HongQi from '../hongqi.vue'
import Icaur from '../Icaur.vue'
import SubmittedSuccess from '../components/SubmittedSuccess.vue'
import eUserInfo from '../components/eUserInfo.vue'
import RtsLogin from '../views/RtsLogin.vue'
import RtsDashboard from '../views/RtsDashboard.vue'
import ActivityPageEdit from '../views/ActivityPageEdit.vue'

// function getLocalePath(path, locale) {
//   return path + (locale ? '-' + locale : ''); // 根据是否提供locale来决定是否添加后缀
// }

// params: { lang: 'zh' },
const routes = [
  // { path: '/', redirect: '/survey' },
  // { path: '/', redirect: '/survey/:lang', component: HomeView, params: { lang: 'zh' } },
  { path: '/', component: HomeView, meta: { title: 'MOTORSHOW' } },
  { path: '/zeekr', component: ZeekrView, meta: { title: 'ZEEKR MOTORSHOW Information Registration' } },
  { path: '/hongqi', component: HongQi, meta: { title: 'HONGQI MOTORSHOW Information Registration' } },
  { path: '/icaur', component: Icaur, meta: { title: 'iCAUR x ARTY: ACTIVE | CENTRESTAGE 2026' } },
  { path: '/succeed', component: SubmittedSuccess },
  { path: '/zeekr/event', component: ZeekrEvent, meta: { title: 'ZEEKR Register now' } },

  { path: '/eUserInfo', component: eUserInfo },
  { path: '/RTS/KLM/', component: RtsLogin },
  { path: '/RTS/KLM/dashboard', component: RtsDashboard, meta: { requiresAuth: true } },
  { path: '/RTS/KLM/activity-page', component: ActivityPageEdit, meta: { requiresAuth: true, title: '活動頁面編輯' } },
  // { path: '/survey/:lang', name: 'HomeView', component: HomeView },
  // { path: '/survey', component: HomeView, params: { lang: 'en' }, meta: { lang: 'en' } },
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})

// 路由守卫：RTS 后台需要登录
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const token = sessionStorage.getItem('rts_token')
    if (!token) {
      next({ path: '/RTS/KLM/' })
    } else {
      next()
    }
  } else {
    next()
  }
})

// 根据路由 meta 设置页面标题
router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router